import React from "react";

import { PRICE_SNAPSHOT_ROLE } from "../../constants";
import DisputeReasonModal from "../DisputeReasonModal";
import PriceComparisonModal from "./PriceComparisonModal";
import PriceInputModal from "../PriceInputModal";
import PricePeriodCreateModal from "../PricePeriodCreateModal";
import PricePeriodDetailDrawer from "../PricePeriodDetailDrawer";

const FuelPriceWorkbenchOverlays = ({
    createModalOpen,
    createLoading,
    vendors,
    onCloseCreate,
    onCreate,
    priceInputState,
    priceInputPeriod,
    priceInputConfig,
    priceInputLoading,
    onClosePriceInput,
    onSubmitPriceInput,
    disputeState,
    disputePeriod,
    disputeLoading,
    onCloseDispute,
    onSubmitDispute,
    comparisonState,
    comparisonPeriod,
    onCloseComparison,
    onViewDetail,
    onOpenOurPrice,
    onOpenSupplierQuote,
    onConfirm,
    onDispute,
    detailState,
    detailPeriod,
    detailLoading,
    detailLogs,
    detailLogsLoading,
    onCloseDetail,
}) => {
    return (
        <>
            <PricePeriodCreateModal
                open={createModalOpen}
                loading={createLoading}
                vendors={vendors}
                onCancel={onCloseCreate}
                onSubmit={onCreate}
            />

            <PriceInputModal
                open={priceInputState.open}
                loading={priceInputLoading}
                title={priceInputConfig.title}
                label={priceInputConfig.label}
                initialValue={
                    priceInputState.snapshotRole === PRICE_SNAPSHOT_ROLE.SUPPLIER_QUOTE
                        ? priceInputPeriod?.supplier_quoted_price
                        : priceInputPeriod?.our_calculated_price
                }
                onCancel={onClosePriceInput}
                onSubmit={onSubmitPriceInput}
            />

            <DisputeReasonModal
                open={disputeState.open}
                loading={disputeLoading}
                period={disputePeriod}
                onCancel={onCloseDispute}
                onSubmit={onSubmitDispute}
            />

            <PriceComparisonModal
                open={comparisonState.open}
                period={comparisonPeriod}
                onClose={onCloseComparison}
                onViewDetail={onViewDetail}
                onOpenOurPrice={onOpenOurPrice}
                onOpenSupplierQuote={onOpenSupplierQuote}
                onConfirm={onConfirm}
                onDispute={onDispute}
            />

            <PricePeriodDetailDrawer
                open={detailState.open}
                period={detailPeriod}
                loading={detailLoading}
                logs={detailLogs}
                logsLoading={detailLogsLoading}
                onClose={onCloseDetail}
            />
        </>
    );
};

export default FuelPriceWorkbenchOverlays;
